import { getHttpGetOptions, getHttpPostOptions, getHttpPutOptions } from '@neslotech/utils';

import { Tombstone } from '../../interfaces/client/tombstone.interface';

import { getAuthHeaders } from '../auth.util';

import { API_HOST, RequestOptions } from './index';

const getTombstonesEndpoint = (): string => `${API_HOST}/tombstones`;
const getTombstoneEndpoint = (id: number | string): string => `${API_HOST}/tombstones/${id}`;

export const getTombstonesRequest = (): RequestOptions => [
  getTombstonesEndpoint(),
  getHttpGetOptions(getAuthHeaders())
];

const getTombstonesCsvEndpoint = (): string => `${getTombstonesEndpoint()}.csv`;
export const getDownloadTombstonesRequest = () => [
  getTombstonesCsvEndpoint(),
  { ...getHttpGetOptions({ ...getAuthHeaders(), Accept: 'text/csv' }), responseType: 'blob' }
];

/** v3: PUT /tombstones/:id with the fields the redesign edits inline. */
export const getUpdateTombstoneV3Request = (
  id: number | string,
  payload: Partial<Tombstone>
): RequestOptions => [
  getTombstoneEndpoint(id),
  getHttpPutOptions({ tombstone: payload }, getAuthHeaders())
];

/** v3: POST /tombstones — top-level create (client_id in the body). */
export const getCreateTombstoneRequest = (payload: Partial<Tombstone>): RequestOptions => [
  getTombstonesEndpoint(),
  getHttpPostOptions({ tombstone: payload }, getAuthHeaders())
];
